// extracted by mini-css-extract-plugin
export default {"root":"DeleteSegmentConfirmation_root__+o8uY","delete-button":"DeleteSegmentConfirmation_delete-button__EQHU4"};